// extracted by mini-css-extract-plugin
export var aiStarIcon = "_l8-2";
export var container = "_l8-4";
export var dismissButton = "_l8-3";
export var hasPaddingBottom = "_l8-6";
export var last = "_l8-e";
export var scrollbarThumb = "_l8-c";
export var scrollbarTrack = "_l8-b";
export var selected = "_l8-9";
export var spin = "_l8-1";
export var spinning = "_l8-0";
export var suggestionItem = "_l8-d";
export var suggestionsPanel = "_l8-5";
export var tonePill = "_l8-8";
export var tonesContainer = "_l8-7";
export var unselected = "_l8-a";